<template>
	<loading-indicator v-if="loading" class="my-5" title="Fetching case..." />
	<validation-observer v-else v-bind="$attrs" ref="observer" v-slot="{ invalid }">
		<b-form @submit.prevent="save">
			<b-card no-body :class="flush ? 'border-0' : ''">
				<b-card-body v-if="showContent" class="mb-0">
					<b-row>
						<b-col col="12" >
							<div v-if="addingPatient" class="mb-4">
										<patient-form @cancel="addingPatient = false" @saved="addedNewPatient">
											<template #header>
												<b-card-header>
													<div class="d-flex justify-content-between align-items-center">
														<span class="font-weight-bold">Add New Patient</span>
														<b-button variant="secondary" size="sm"
															@click="addingPatient = false" title="Cancel" class="mb-0">
															<font-awesome-icon icon="remove" fixed-width
																class="my-0 py-0" />
														</b-button>
													</div>
												</b-card-header>
											</template>
										</patient-form>
							</div>
							<div v-if="addingFacility" class="mb-4">
								<h6 class="text-muted">Add New Facility</h6>

								<facility-form @saved="addedFacility" @cancel="addingFacility = false" />
							</div>
							<div v-if="addingInsuranceProvider" class="mb-4">
								<insurance-provider-form @cancel="addingInsuranceProvider = false"
									@saved="addedNewInsuranceProvider">
									<template #header>
										<b-card-header>
											<div class="d-flex justify-content-between align-items-center">
												<span class="font-weight-bold">Add New Insurance Provider</span>
												<b-button variant="secondary" size="sm"
													@click="addingInsuranceProvider = false" title="Cancel" class="mb-0">
													<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
												</b-button>
											</div>
										</b-card-header>
									</template>
								</insurance-provider-form>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col col="12" md="6">
							<validation-provider vid="patient_id" name="Patient" :rules="{ required: true }"
								v-slot="validationContext">
								<div v-if="!hidePatient">
									<div v-if="addingPatient" class="mb-4">
										<!-- <patient-form @cancel="addingPatient = false" @saved="addedNewPatient">
											<template #header>
												<b-card-header>
													<div class="d-flex justify-content-between align-items-center">
														<span class="font-weight-bold">Add New Patient</span>
														<b-button variant="secondary" size="sm"
															@click="addingPatient = false" title="Cancel" class="mb-0">
															<font-awesome-icon icon="remove" fixed-width
																class="my-0 py-0" />
														</b-button>
													</div>
												</b-card-header>
											</template>
										</patient-form> -->
									</div>
									<div v-else-if="editingPatient" class="mb-4">
										<patient-form :id="editingPatient" @cancel="editingPatient = false"
											@saved="savedPatient">
											<template #header>
												<b-card-header>
													<div class="d-flex justify-content-between align-items-center">
														<span class="font-weight-bold">Edit Patient</span>
														<b-button variant="secondary" size="sm"
															@click="editingPatient = false" title="Cancel" class="mb-0">
															<font-awesome-icon icon="remove" fixed-width
																class="my-0 py-0" />
														</b-button>
													</div>
												</b-card-header>
											</template>
										</patient-form>
									</div>
									<div v-else>
										<validation-provider vid="currentPatient" name="Patient" :rules="{ required: true, min: 1, max: 50 }" v-slot="validationContext">
											<b-form-group label="Patient" label-for="patient" label-cols-lg="4">
												<patient-search name="currentPatient" v-model="currentPatient" @add="addingPatient = true"
																:disabled="saving" :state="getValidationState(validationContext)" @no-results="handleNoResults" />
												<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
																		v-text="error" />
											</b-form-group>
										</validation-provider>
										<b-row v-if="currentPatient && currentPatient.id">
											<b-col cols="12" lg="8" offset-lg="4" class="mb-4">
												<div class="d-flex justify-content-between align-items-center">
													<div>
														<h2 class="h3 my-0 mb-1 font-weight-bold text-uppercase"
															v-text="currentPatient.list_name" />
														<h3 v-if="currentPatient.date_of_birth"
															class="h6 mt-0 mb-1 text-muted text-uppercase">
															<span class="font-weight-bold">
																{{ $filters.formatDate(currentPatient.date_of_birth) }}
															</span>
																    <span v-if="currentPatient.age !== 0">&mdash; </span>
																		<font-awesome-icon v-if="currentPatient.is_birthday" class="text-muted" />
																		<span class="font-weight-bold" v-if="currentPatient.age !== 0">
																			{{ currentPatient.age }}
																		<span class="text-lowercase">yrs</span>
																	</span>

														</h3>
														<h3 v-else class="h6 mt-0 mb-1 text-warning">(Missing DOB)</h3>
													</div>

													<b-button variant="light" class="mb-0" @click="editPatient">
														<font-awesome-icon icon="edit" fixed-width />
														<span>Edit Patient</span>
													</b-button>
												</div>
											</b-col>
										</b-row>
									</div>
								</div>
								<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
									v-text="error" />
							</validation-provider>
						</b-col>
					</b-row>
					<b-row>
						<b-col col="12">
							<b-form-group label="Case Type" label-for="case_type" label-cols-lg="2">
								<b-form-radio-group v-model="entity.case_type_id">
									<b-form-radio id="pre" name="case_type" value="1">Pre-Payment</b-form-radio>
									<b-form-radio id="post" name="case_type" value="2" checked>Post-Payment</b-form-radio>
								</b-form-radio-group>
							</b-form-group>

						</b-col>
					</b-row>
					<b-row>

					</b-row>
					<b-row>
						<b-col cols="12">
							<validation-provider ref="facilityNameValidationProvider" vid="facilitySearch" name="Facility Name" :rules="{ required: true}" v-slot="validationContext">
								<b-form-group label="Facility Name" label-for="facilitySearch" label-cols-lg="2">
								<b-input-group>
										<b-form-input
											name="facilitySearch"
											v-model="facilitySearch"
											style="flex: 1; padding: 8px; border-radius: 4px;"
											class="custom-rounded-border" 
											placeholder="Required"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											@input="searchFacilities"
										/>


										<!-- Append button -->
										<template #append>
										<b-button variant="success" @click="addingFacility = !addingFacility"
											:active="addingFacility">
											<font-awesome-icon icon="plus" fixed-width />
										</b-button>
									</template>
								</b-input-group>
									<span class="text-muted small" v-if="entity.facility_name !== null"><span>{{entity.facility_name}}</span></span>
									<span class="text-muted small" v-if="isEncore"><span>| {{isEncore ? "Encore":""}}</span></span>
									<span class="text-muted small" v-if="entity.has_contract">| Has Contract</span>
									<span class="text-muted small" v-if="term_date !== null && entity.facility_name !== 'Active'">| Term Date: <span>{{term_date}}</span></span>
									<span class="text-muted small" v-if="division"><span> | {{division}}</span></span>
									<!-- <span class="text-muted small" v-if="entity.bill_type">| Bill Type: {{ entity.bill_type }}</span> -->
									<!--<span v-if="entity.has_contract" class="badge bg-secondary">Has Contract</span>
									<span v-if="entity.facility_name !== null" class="badge bg-secondary">Status : {{ entity.facility_name }}</span>
									<span v-if="term_date !== null && entity.facility_name !== 'Active'" class="badge bg-secondary">Term Date: {{ term_date }}</span>-->

									<!-- <span class="text-muted small">Encore Audit Number = 1234567890 |</span> -->
									<!-- Display filtered options in a list -->
									<div>
										<div class="custom-dropdown-option"
											v-if="searchResults.length > 0 && facilitySearch !== ''">
											<b-row v-for="(item, index) in searchResults.slice(0, 20)" :key="index"
												@click="() => selectFacility(item)">
												<b-col class="custom-option-col">
													<div class="option-content">
														 <!-- Content for the option  -->
														<p>
															<span title="Facility">
																{{ item.displayName }}
															</span>
															
															<span>
																<b-badge pill 
																		v-if="item.is_encore === 1"
																		variant="success" 
																		title="inactive" 
																		style="background-color: #e49643; color: white;" 
																	>
																		Encore  
																</b-badge>
															</span>
															<span>
																<b-badge pill 
																	v-if="item.has_contract"
																	variant="info" 
																	title="inactive" 
																>
																	Contract  
																</b-badge>
															</span>
															<span>
																<b-badge pill 
																	v-if="item.is_duplicate"
																	variant="warning" 
																	title="inactive" 
																>
																	Duplicate  
																</b-badge>
															</span>
														</p>
													</div>
												</b-col>
											</b-row>
										</div>
									</div>
									<div v-if="descriptionFacility" class="bg-light rounded text-muted px-4 py-2">
										{{ descriptionFacility }}
									</div>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>

								
							</validation-provider>

							<!-- TODO: ADD A PLUS ICON TO DISPLAY BELOW COMPONEt -->
							<!-- <div v-if="addingFacility" class="mb-4">
								<h6 class="text-muted">Add New Facility</h6>

								<facility-form @saved="addedFacility" @cancel="addingFacility = false" />
							</div> -->

							<!-- Facility Contract -->
							<!-- <validation-provider
									vid="has_contract"
									name="Contract"
									:rules="{ required: false }"
									v-slot="validationContext"
									v-if="entity.has_contract"
							>
								<b-form-group
									label="Contract"
									label-for="has_contract"
									label-cols-lg="4"
									
								>
									<b-form-checkbox
										name="has_contract"
										:checked="entity.has_contract"
										:disabled="true"
										:state="getValidationState(validationContext)"
									>
										Has Contract
									</b-form-checkbox>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"  
									/>
								</b-form-group>
							</validation-provider> -->
						</b-col> 
						</b-row>
						<b-row>
						<b-col cols="12" md="6" v-if="isEncore">
							<div v-if="isEncore && hideEncoreAuditNo">
								<validation-provider vid="encore_audit_number" name="Encore Audit Number" :rules="{ required: false }"
								v-slot="validationContext">
								<b-form-group label="Encore Audit Number" label-for="encore_audit_number" label-cols-lg="4" v-if="isEncore">
								<b-form-input name="encore_audit_number" v-model="entity.encore_audit_number" :disabled="saving"
								:state="getValidationState(validationContext)" type="text" autocomplete="off" readonly/>
								<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"v-text="error" />
								</b-form-group>
								</validation-provider>
							</div>
						</b-col>
						<b-col col="12" md="6">
							<!-- <validation-provider
									vid="facility_status"
									name="Facility Status"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
								<b-form-group label="Facility Status" label-for="facility_status" label-cols-lg="4">
                                    <b-form-input
                                        name="facility_name"
                                        v-model="entity.facility_name"
                                        :disabled="saving"
                                        readonly
                                        type="text"
                                        autocomplete="off"
                                    />
                                </b-form-group>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider> -->
								<!-- <b-form-group label="Facility Status" v-if="entity.facility_name !== null" label-for="facility_status" label-cols-lg="4">
									<b-form-input
										name="facility_status"
										v-model="entity.facility_name"
										:disabled="saving"
										readonly
										type="text"
										autocomplete="off"
									/>
								</b-form-group> -->
								<!-- Term Date -->
								<!-- <b-form-group label="Facility Term Date" v-if="term_date !== null && entity.facility_name !== 'Active'" label-for="term_date" label-cols-lg="4">
									<b-form-input
										name="term_date"
										v-model="term_date"
										:disabled="saving"
										readonly
										type="text"
										autocomplete="off"
										:style="{ color: entity.facility_name === 'Inactive' ? 'red' : 'inherit' }"
									/>
								</b-form-group> -->
								
								</b-col>
						</b-row>
					<b-row>
						<b-col cols="12" md="6">
							<b-form-group label="LOB" label-for="bill_type" label-cols-lg="4" v-if="facilitySearch">
									<b-form-select name="bill_type" 
										v-model="entity.bill_type" 
										:options="billTypeOptions" 
										value-field="abbreviation" 
										text-field="name" 
										:disabled="saving"
										@change="update">
									</b-form-select>
							</b-form-group>
						</b-col>	
					</b-row>	
					<b-row>

						 <b-col cols="12" md="6">
      <validation-provider
        ref="admitDateValidationProvider"
        vid="admit_date"
        name="Begin DOS"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-form-group label="Begin DOS" label-for="admit_date" label-cols-lg="4">
          <b-form-input
            name="admit_date"
            :min="minDate"
            :max="yesterday"
            type="date"
            v-model="entity.admit_date"
            :disabled="saving"
            :state="getValidationState(validationContext)"
            @input="updateDischargeMinDate"
          />
          <b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col cols="12" md="6">
      <validation-provider
        ref="dischargeDateValidationProvider"
        vid="discharge_date"
        name="End DOS"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-form-group label="End DOS" label-for="discharge_date" label-cols-lg="4">
          <b-form-input
            name="discharge_date"
            type="date"
            :min="minDischargeDate"
            :max="today"
            v-model="entity.discharge_date"
            :disabled="saving"
            :state="getValidationState(validationContext)"
            @change="validateDates"
          />
          <b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
        </b-form-group>
      </validation-provider>
    </b-col>	
                </b-row>
					<b-row>
						<!--make change the label from Visit / MRN to ‘RCM Invoice #’ due to request of powerback -->
						<b-col cols="12" md="6">
							<validation-provider vid="visit_number" name="Visit ID/Number" :rules="{ required: false }"
								v-slot="validationContext">
								<b-form-group label="RCM Invoice #" label-for="visit_number" label-cols-lg="4">
									<b-form-input name="visit_number" v-model="entity.visit_number" :disabled="saving"
										:state="getValidationState(validationContext)" type="text" autocomplete="off" />
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
						</b-col>
						<b-col cols="12" md="6">
							<validation-provider vid="mrt_number" name="MRT#" :rules="{ required: false }"
								v-slot="validationContext">
								<b-form-group label="MRT#" label-for="mrt_number" label-cols-lg="4">
									<b-form-input name="mrt_number" v-model="entity.mrt_number" :disabled="saving"
										:state="getValidationState(validationContext)" type="text" autocomplete="off" />
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" md="6">
							<validation-provider vid="insurance_provider_id" name="Insurance Provider"
								:rules="{ required: true}" v-slot="validationContext">
								<b-form-group label="Insurance Provider" label-for="insurance_provider" label-cols-lg="4">
									<b-input-group>
										<b-select name="insurance_provider_id" v-model="entity.insurance_provider_id"
											:options="activeProviders" :disabled="saving || loadingInsuranceProviders"
											value-field="id"
											text-field="name" 
											@change="changedInsuranceProvider" 
											required="required"
											placeholder="Required"
											:state="getValidationState(validationContext)"
										>
											<!-- <template #first>
												<b-select-option :value="null"> (None) </b-select-option>
											</template> -->
										</b-select>
										<template #append>
											<b-button variant="success"
												@click="addingInsuranceProvider = !addingInsuranceProvider"
												:active="addingInsuranceProvider">
												<font-awesome-icon icon="plus" fixed-width />
											</b-button>
										</template>
									</b-input-group>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>

							<!-- <div v-if="addingInsuranceProvider" class="mb-4">
								<insurance-provider-form @cancel="addingInsuranceProvider = false"
									@saved="addedNewInsuranceProvider">
									<template #header>
										<b-card-header>
											<div class="d-flex justify-content-between align-items-center">
												<span class="font-weight-bold">Add New Insurance Provider</span>
												<b-button variant="secondary" size="sm"
													@click="addingInsuranceProvider = false" title="Cancel" class="mb-0">
													<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
												</b-button>
											</div>
										</b-card-header>
									</template>
								</insurance-provider-form>
							</div> -->
						</b-col>
						<b-col cols="12" md="6">
							<validation-provider v-if="isManagedByRequired" vid="managed_by" name="Managed By"
								:rules="{ required: false }" v-slot="validationContext">
								<b-form-group label="Managed By" label-for="managed_by" label-cols-lg="4">
									<b-input-group>
										<b-select name="managed_by" v-model="entity.managed_by"
											:options="filteredInsuranceProviders" :disabled="saving || loadingInsuranceProviders"
											:state="getValidationState(validationContext)" value-field="id"
											text-field="name">
											<template #first>
												<b-select-option :value="null"> Unknown </b-select-option>
											</template>
										</b-select>
									</b-input-group>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" md="12">
							<b-form-group label="Disciplines" label-for="discipline_ids" label-cols-lg="2">
									<b-form-checkbox-group
										name="discipline_ids"
										v-model="disciplineIds"
										:options="disciplines"
										:disabled="saving || loadingDisciplines"
										value-field="id"
										text-field="name"
									/>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<!-- adding new column Insurance Type -->
						<b-col cols="12" md="6">
							<!-- add insurance provider type -->
							<validation-provider v-if="entity.insurance_provider_id !== null" vid="insurance_provider_type" name="Insurance Provider Types"
								:rules="{ required: false }" v-slot="validationContext">
								<b-form-group label="Insurance Provider Types" label-for="insurance_provider_type" label-cols-lg="4">
									<b-input-group>
										<b-select name="insurance_provider_type" v-model="entity.insurance_provider_type"
											:options="insuranceProviderTypes[0]" :disabled="saving || loadingInsuranceProviders"
											:state="getValidationState(validationContext)" value-field="id"
											text-field="insurance_provider_type">
											<!-- <template #first>
												<b-select-option :value="null"> (None) </b-select-option>
											</template> -->
										</b-select>
									</b-input-group>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
						</b-col>
					
					
						<b-col cols="12" md="6">
							<validation-provider
								v-if="iscontract"
								vid="insurance_type"
								name="Insurance Rate Type"
								:rules="{ required: false }"
								v-slot="validationContext"
							>
								<b-form-group label="Insurance Rate Type" label-for="Insurance Type" label-cols-lg="4">
									<b-form-select
										name="insurance_type"
										v-model="entity.insurance_type"
										:disabled="saving"
										:state="getValidationState(validationContext)"
										:options="insuranceOptions"
										
									>
										<template v-slot:first>
											<!-- This is optional, in case you want a non-selectable prompt -->
											<option disabled value="">Please select one</option>
										</template>
									</b-form-select>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
                     </b-col>
					 </b-row>
					 <b-row>
					 <b-col>
							<validation-provider vid="case_type_id" name="Audit Type" :rules="{ required: false }"
								v-slot="validationContext">
								<b-form-group label="Audit Type" label-for="case_type_id" label-cols-lg="4">
									<b-form-select name="case_type_id" v-model="entity.insurance_type_id"
										:options="insuranceTypesList" :disabled="saving || loadingInsuranceTypes"
										:state="getValidationState(validationContext)" value-field="id" text-field="name" >
										<!-- <template v-slot:first>
											This is optional, in case you want a non-selectable prompt
											<option disabled value="0">Unknown</option>
										</template> -->
									</b-form-select>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
						</b-col>
						
						<!-- <validation-provider
								vid="insurance_type_id"
								name="Insurance Type"
								:rules="{ required: true }"
								v-slot="validationContext"
							>
								<b-form-group label="Insurance Type" label-for="insurance_type_id" label-cols-lg="4">
									<b-select
										name="insurance_type_id"
										v-model="entity.insurance_type_id"
										:options="availableInsuranceTypes"
										:disabled="saving || loadingInsuranceTypes"
										:state="getValidationState(validationContext)"
										value-field="id"
										text-field="name"
										required="required"
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider> -->
						
					
						<b-col cols="12" md="6">
							<validation-provider vid="client_employee_id" name="Primary Employee"
								:rules="{ numeric: false }" v-slot="validationContext">
								<b-form-group label="Primary Physician" label-for="client_employee_id" label-cols-lg="4"
									description="The licensed physician responsible for this case">
									<b-input-group>
										<b-form-select name="client_employee_id" v-model="entity.client_employee_id"
											:options="clientEmployees" :disabled="saving || loadingClientEmployees"
											:state="getValidationState(validationContext)" value-field="id"
											text-field="full_name" disabled>
											<template #first>
												<option disabled v-if="!hasClientEmployees" :value="null">
													No physicians added.
												</option>
											</template>
										</b-form-select>
										<template #append>
											<!-- <b-button variant="primary" :to="{ name: 'clientEmployees.add.npi.cases', params: { id: entity.id } }" -->
											<b-button variant="success" style="width:44px;" :to="{
												name: entity.id ? 'clientEmployees.add.npi.cases' : 'clientEmployees.add.npi.newcase',
												params: { id: entity.id }
											}" title="Add from NPI Registry" disabled>
												<font-awesome-icon icon="plus" fixed-width />
												<!-- <span>Add</span> -->
											</b-button>
											<!-- <b-button
												variant="primary"
												@click="addingClientEmployee = !addingClientEmployee"
												:active="addingClientEmployee"
											>
												<font-awesome-icon icon="plus" fixed-width />
											</b-button> -->
										</template>
									</b-input-group>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>

							<div v-if="addingClientEmployee" class="mb-4">
								<client-employee-form @saved="addedClientEmployee" @cancel="addingClientEmployee = false">
									<template #header>
										<b-card-header>
											<div class="d-flex justify-content-between align-items-center">
												<span class="font-weight-bold">Add New Physician</span>
												<b-button variant="secondary" size="sm"
													@click="addingClientEmployee = false" title="Cancel" class="mb-0">
													<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
												</b-button>
											</div>
										</b-card-header>
									</template>
								</client-employee-form>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" md="6">
							<b-form-group id="utc" label="Unable To Complete" label-for="utc" label-cols-lg="4"
								description="This case is unable to be progressed any further">
								<b-form-checkbox name="utc" v-model="entity.unable_to_complete" :disabled="saving">
									UTC
								</b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col cols="12" md="6">
							<validation-provider vid="assigned_to" name="Assigned To" :rules="{ required: false }"
								v-slot="validationContext">
								<b-form-group label="Assigned To" label-for="assigned_to" label-cols-lg="4">
									<b-form-select v-model="entity.assigned_to" name="assigned_to" :options="users"
										:disabled="saving" value-field="id" text-field="full_name">
										<template #first>
											<option :value="null">(Unassigned)</option>
										</template>
									</b-form-select>
									<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
										v-text="error" />
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>
				</b-card-body>
				<!-- <div @click="toggleContent" class="half-arrow mt-2 cursor-pointer d-flex justify-content-center align-items-center">
      				<font-awesome-icon :icon="showContent ? 'chevron-up' : 'chevron-down'" />
					
					  <p class="mt-3 ml-2">{{ showContent ? 'Hide' : 'Show' }}</p>
    			</div> -->
				<b-card-body>
					<h6 class="text-muted">Additional</h6>

					<b-card no-body>
						<!-- <b-card-header header-tag="header" role="tab" class="p-0" v-if="id">
							<b-button block v-b-toggle.collapseDenial variant="light" role="tab"
								class="text-left px-4 py-3 m-0">
								Audit Denial Details
							</b-button>
						</b-card-header>
						<b-collapse id="collapseDenial" role="tabpanel" v-if="id">
							<b-card-body>

								<table class="table table-bordered table-striped" v-if="showTable">
									<thead>
										<tr>
											<th class="text-muted">Appeal Level ID</th>
											<th>Appeal Level</th>
											<th>Denial Type</th>
											<th>Denial Reason</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="data in denialData" :key="data.id">
											<td class="align-middle text-muted">{{ data.appeal_id }}</td>
											<td class="align-middle">{{ data.appeal.insurance_provider_appeal_level.label }}</td>
											<td class="align-middle">{{ data.denial_type.name }}</td>
											<td class="align-middle">{{ data.denial_reason.name }}</td>
										</tr>
									</tbody>
								</table>

								<empty-result v-else>
									Audit Denial Data NOT AVAILABLE
									<template #content> There are no audit denial types and reasons data for this case.</template>
								</empty-result> -->


								<!-- <b-row v-for="data in denialData" :key="data.id">
									<h4>{{data.appeal.insurance_provider_appeal_level.label}}</h4>
									<b-col cols="12" md="4">
										<b-form-group label="Denial Type" label-for="denial_type_id" label-cols-lg="4">
											<b-select name="denial_type_id" v-model="data.denial_type_id" :options="denialTypes" :disabled="true" value-field="id" text-field="name">
											<template #first>
												<option :value="null">(None)</option>
											</template>
											</b-select>
										</b-form-group>
										
									</b-col>
									<b-col cols="12" md="4">
										
										<b-form-group label="Denial Reason"  label-cols-lg="4">
											<b-select name="denial_type_id" v-model="data.denial_reason_id" :options="denialReasonsOptions" :disabled="true" value-field="id" text-field="name">
											<template #first>
												<option :value="null">(None)</option>
											</template>
											</b-select>
										</b-form-group>
									</b-col>
								</b-row> -->
								<!-- <b-row>
									
									<b-col cols="12" md="4">
										<validation-provider vid="denial_type_id" name="Denial Type" :rules="{ required: false }" v-slot="validationContext">
										<b-form-group label="Denial Type" label-for="denial_type_id" label-cols-lg="4">
											<b-select name="denial_type_id" v-model="entity.denial_type_id" :options="denialTypes" :disabled="saving || loadingDenialTypes" :state="getValidationState(validationContext)" value-field="id" text-field="name">
											<template #first>
												<option :value="null">(None)</option>
											</template>
											</b-select>
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
										</b-form-group>
										</validation-provider>
									</b-col>

									
									<b-col cols="12" md="8">
										<div v-if="addingDenialReason">
										<denial-reason-form autofocus @cancel="addingDenialReason = false" @saved="addedNewDenialReason">
											
										</denial-reason-form>
										</div>
										<div v-else>
										<b-form-group label="Denial Reasons" tabindex="1" label-for="denial_reasons" label-cols-lg="2">
											<denial-reason-search-multi name="denial_reasons" v-model="currentDenialReasons" @add="addingDenialReason = true" :disabled="saving" />
											
											<b-row class="mt-1" v-if="currentDenialReasons.length">
											
											<b-col sm="12" lg="12">
												<div class="selected-item">
												<div v-if="!currentDenialReasons.length">
													<empty-result>
													No reasons added.
													</empty-result>
												</div>
												<div v-else>
													<h6 class="border_bottom" style="padding-bottom: 14px;">
													Selected reason-
													<span style="float: right;">
														<font-awesome-icon icon="trash" @click.stop="toggleDeleteMode" style="cursor: pointer;" />
													</span>
													</h6>
													<div v-for="(selectedItem, index) in currentDenialReasons" :key="index" class="border_bottom">
													<p>
														<input type="checkbox" v-if="deleteFacilityMode" v-model="selectedItem.checked" />
														<span>
														<font-awesome-icon icon="bars" style="padding-right: 8px;" />{{ selectedItem.name }}
														</span>
													</p>
													</div>
													<div v-if="deleteFacilityMode" style="display: flex; justify-content: space-between; margin-top: 5px;">
													<button @click="cancelFacilityDeleteMode" class="btn btn-secondary btn-sm">Cancel</button>
													<button @click="removeSelectedItems" class="btn btn-danger btn-sm">Remove</button>
													</div>
												</div>
												</div>
											</b-col>
											</b-row>
										</b-form-group>
										</div>
									</b-col>
									</b-row> -->

								
									<!-- Powerback Denial Reason -->
									<!-- <div class="col-lg-8 col-md-9">
										<validation-provider vid="pwrbck_deny_res" name="Powerback Denial Reason" :rules="{ required: false }"
											v-slot="validationContext">
											<b-form-group label="Powerback Denial Reason" label-for="pwrbck_deny_res" label-cols-lg="2">
												<b-select v-model="selectedDenialReason" name="pwrbck_denial_reason"
													:state="getValidationState(validationContext)">
													<template #first>
														<option :value="null">(None)</option>
													</template>
													<option v-for="reason in denialReasons[0]" :key="reason.id" :value="reason.id">
														{{ reason.reason }}
													</option>
												</b-select>
												<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
													v-text="error" />
											</b-form-group>
										</validation-provider>
									</div> -->
							
							<!-- </b-card-body>

						</b-collapse> -->
						<!-- <b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseDisciplines
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>
								Disciplines
							</b-button>
						</b-card-header>
						<b-collapse id="collapseDisciplines" role="tabpanel">
							<b-card-body>
								<b-form-group label="Disciplines" label-for="discipline_ids" label-cols-lg="4">
									<b-form-checkbox-group
										stacked
										name="discipline_ids"
										v-model="disciplineIds"
										:options="disciplines"
										:disabled="saving || loadingDisciplines"
										value-field="id"
										text-field="name"
									/>
								</b-form-group>
							</b-card-body>
						</b-collapse> -->


						<!-- <b-card-header header-tag="header" role="tab" class="p-0">
							<b-button block v-b-toggle.collapseClaimBillingCodes variant="light" role="tab"
								class="text-left px-4 py-3 m-0">
								Claim Details
							</b-button>
						</b-card-header> -->
						<!-- <b-collapse id="collapseClaimBillingCodes" role="tabpanel">
							 <b-card-body>
								<div class="d-flex">
									<b-button
										variant="secondary"
										@click="addReadmission"
										:disabled="!canAddReadmission"
										class="ml-auto"
									>
										<font-awesome-icon icon="plus" fixed-width />
										<span>Add Codes</span>
									</b-button>
								</div>
							</b-card-body> 
							<b-card-body>
								<b-row>
									<b-col cols="12" md="6">
										<p class="font-weight-bold">Claim Billing Codes</p>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12" md="6">
										<validation-provider vid="insurance_plan" name="Insurance Plan"
											:rules="{ required: false, max: 50 }" v-slot="validationContext">
											<b-form-group label="ICD-10-CM codes" label-for="insurance_plan"
												label-cols-lg="4">
												<b-form-input name="insurance_plan" type="text" v-model="entity.icdCodes10"
													:disabled="saving" :state="getValidationState(validationContext)" />
												<b-form-invalid-feedback v-for="error in validationContext.errors"
													:key="error" v-text="error" />
											</b-form-group>
										</validation-provider>
									</b-col>
									<b-col cols="12" md="6">
										<validation-provider vid="insurance_number" name="Insurance Plan ID / Number"
											:rules="{ required: false, max: 50 }" v-slot="validationContext">
											<b-form-group label="CPT Codes" label-for="insurance_number" label-cols-lg="4">
												<b-form-input name="insurance_number" type="text" v-model="entity.cptCodes"
													:disabled="saving" :state="getValidationState(validationContext)" />
												<b-form-invalid-feedback v-for="error in validationContext.errors"
													:key="error" v-text="error" />
											</b-form-group>
										</validation-provider>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12" md="6">
										<validation-provider vid="insurance_number" name="Insurance Plan ID / Number"
											:rules="{ required: false, max: 50 }" v-slot="validationContext">
											<b-form-group label="ICD-10-PCS codes" label-for="insurance_number"
												label-cols-lg="4">
												<b-form-input name="insurance_number" type="text" v-model="entity.icdCodes"
													:disabled="saving" :state="getValidationState(validationContext)" />
												<b-form-invalid-feedback v-for="error in validationContext.errors"
													:key="error" v-text="error" />
											</b-form-group>
										</validation-provider>
									</b-col>
									<b-col cols="12" md="6">
										<validation-provider vid="insurance_number" name="Insurance Plan ID / Number"
											:rules="{ required: false, max: 50 }" v-slot="validationContext">
											<b-form-group label="HCPCS codes" label-for="insurance_number"
												label-cols-lg="4">
												<b-form-input name="insurance_number" type="text"
													v-model="entity.insurance_number" :disabled="saving"
													:state="getValidationState(validationContext)" />
												<b-form-invalid-feedback v-for="error in validationContext.errors"
													:key="error" v-text="error" />
											</b-form-group>
										</validation-provider>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12" md="6">
										<p class="font-weight-bold">Claim Denial Codes</p>
									</b-col>
								</b-row>
								<b-row>
									<b-col cols="12" md="6">
										<validation-provider vid="insurance_plan" name="CARCs"
											:rules="{ required: false, max: 50 }" v-slot="validationContext">
											<b-form-group label="CARCs" label-for="insurance_plan" label-cols-lg="4">
												<b-form-input name="insurance_plan" type="text" v-model="entity.carcs"
													:disabled="saving" :state="getValidationState(validationContext)" />
												<b-form-invalid-feedback v-for="error in validationContext.errors"
													:key="error" v-text="error" />
											</b-form-group>
										</validation-provider>
									</b-col>
									<b-col cols="12" md="6">
										<validation-provider vid="insurance_number" name="Insurance Plan ID / Number"
											:rules="{ required: false, max: 50 }" v-slot="validationContext">
											<b-form-group label="RARCs" label-for="insurance_number" label-cols-lg="4">
												<b-form-input name="insurance_number" type="text" v-model="entity.rarcs"
													:disabled="saving" :state="getValidationState(validationContext)" />
												<b-form-invalid-feedback v-for="error in validationContext.errors"
													:key="error" v-text="error" />
											</b-form-group>
										</validation-provider>
									</b-col>
								</b-row>
							</b-card-body>

							<case-readmissions
								v-if="hasReadmissions"
								v-model="entity.case_readmissions"
								:disabled="saving"
							/>
							<b-card-body v-else>
								<empty-result icon="list"
									>No Codes
									<template #content> Add Billing Codes. </template>
								</empty-result>
							</b-card-body> 
						</b-collapse> -->


						<!--	<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseClaimDenialCodes
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>
								Claim Denial Codes
							</b-button>
						</b-card-header>

						<b-collapse id="collapseClaimDenialCodes" role="tabpanel">
							<b-card-body>
								
							</b-card-body>
						</b-collapse> -->
						<!-- <b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseFacility
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>
								Facility &amp; Visit Details
							</b-button>
						</b-card-header> -->
						<!-- <b-collapse id="collapseFacility" role="tabpanel">
							<b-card-body>
								<validation-provider
									vid="facility_id"
									name="Facility"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Facility" label-for="facility" label-cols-lg="4">
										<b-input-group>
											<b-form-select
												name="facility_id"
												v-model="entity.facility_id"
												:options="facilities"
												:disabled="saving || loadingFacilities"
												:state="getValidationState(validationContext)"
												value-field="id"
												text-field="name"
											>
												<template #first>
													<option :value="null">(None)</option>
												</template>
											</b-form-select>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
											<template #append>
												<b-button
													variant="primary"
													@click="addingFacility = !addingFacility"
													:active="addingFacility"
												>
													<font-awesome-icon icon="plus" fixed-width />
												</b-button>
											</template>
										</b-input-group>
									</b-form-group>
								</validation-provider>

								<div v-if="addingFacility" class="mb-4">
									<h6 class="text-muted">Add New Facility</h6>

									<facility-form @saved="addedFacility" @cancel="addingFacility = false" />
								</div>

								<validation-provider
									vid="visit_number"
									name="Visit ID/Number"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Visit ID / Number" label-for="visit_number" label-cols-lg="4">
										<b-form-input
											name="visit_number"
											v-model="entity.visit_number"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											type="text"
											autocomplete="off"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<validation-provider
									vid="encore_audit_number"
									name="Visit ID/Number"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Visit ID / Number" label-for="encore_audit_number" label-cols-lg="4">
										<b-form-input
											name="encore_audit_number"
											v-model="entity.encore_audit_number"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											type="text"
											autocomplete="off"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>
							</b-card-body>
						</b-collapse> -->

						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button block v-b-toggle.collapseFinancial variant="light" role="tab"
								class="text-left px-4 py-3 m-0">
								Financial Details
							</b-button>
						</b-card-header>
						<b-collapse id="collapseFinancial" ref="collapseFinancial" role="tabpanel" v-model="collapseVisible">
							<b-card-body>
								<validation-provider vid="total_claim_amount" name="Total Claim Amount" ref="totalClaimAmountValidationProvider"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Total Claim Amount" label-for="total_claim_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="Paid Claim Amount"
												v-model="entity.total_claim_amount" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
												step="0.01" maxlength="10" autocomplete="off" />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>

								<validation-provider vid="disputed_amount" name="Initial Denial Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Initial Denial Amount" label-for="disputed_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="disputed_amount" type="number"
											v-model="entity.disputed_amount" :disabled="saving"
											:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
											step="0.01" maxlength="13" autocomplete="off" readonly/>
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>

								<validation-provider v-if="iscontract" vid="reimbursement_amount"
									name="Reimbursement Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Actual)" label-for="reimbursement_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="reimbursement_amount" type="number"
												v-model="entity.reimbursement_amount" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
												step="0.00" maxlength="10" autocomplete="off" readonly />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
								<validation-provider v-if="iscontract" vid="reimburse_amount" name="Reimburse Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Calculated)" label-for="reimburse_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="contract_paid_amt_est" type="number"
												v-model="entity.contract_paid_amt_est" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
												step="0.00" maxlength="10" autocomplete="off" readonly />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-card-body>
						</b-collapse>

						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button block v-b-toggle.collapseInsurance variant="light" role="tab"
								class="text-left px-4 py-3 m-0">
								Insurance Details
							</b-button>
						</b-card-header>
						<b-collapse id="collapseInsurance" role="tabpanel">
							<b-card-body>
								<validation-provider vid="insurance_plan" name="Insurance Plan"
									:rules="{ required: false, max: 50 }" v-slot="validationContext">
									<b-form-group label="Plan Name" label-for="insurance_plan" label-cols-lg="4">
										<b-form-input name="insurance_plan" type="text" v-model="entity.insurance_plan"
											:disabled="saving" :state="getValidationState(validationContext)" />
										<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
											v-text="error" />
									</b-form-group>
								</validation-provider>

								<validation-provider vid="insurance_number" name="Insurance Plan ID / Number"
									:rules="{ required: false, max: 50 }" v-slot="validationContext">
									<b-form-group label="Plan ID / Number" label-for="insurance_number" label-cols-lg="4">
										<b-form-input name="insurance_number" type="text" v-model="entity.planID"
											:disabled="saving" :state="getValidationState(validationContext)" />
										<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
											v-text="error" />
									</b-form-group>
								</validation-provider>
							</b-card-body>
						</b-collapse>

						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button block v-b-toggle.collapseReadmissions variant="light" role="tab"
								class="text-left px-4 py-3 m-0">
								Readmissions
							</b-button>
						</b-card-header>
						<b-collapse id="collapseReadmissions" role="tabpanel">
							<b-card-body>
								<div class="d-flex">
									<b-button variant="secondary" @click="addReadmission" :disabled="!canAddReadmission"
										class="ml-auto">
										<font-awesome-icon icon="plus" fixed-width />
										<span>Add Readmission</span>
									</b-button>
								</div>
							</b-card-body>
							<case-readmissions v-if="hasReadmissions" v-model="entity.case_readmissions"
								:disabled="saving" />
							<b-card-body v-else>
								<empty-result icon="list">No readmissions
									<template #content> Add readmissions to track multiple service dates. </template>
								</empty-result>
							</b-card-body>
						</b-collapse>

						<!-- <b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseClaimBillingCodes
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>
							Claim Billing Codes
							</b-button>
						</b-card-header>
						<b-collapse id="collapseClaimBillingCodes" role="tabpanel"> -->
						<!-- <b-card-body>
								<div class="d-flex">
									<b-button
										variant="secondary"
										@click="addReadmission"
										:disabled="!canAddReadmission"
										class="ml-auto"
									>
										<font-awesome-icon icon="plus" fixed-width />
										<span>Add Codes</span>
									</b-button>
								</div>
							</b-card-body> -->
						<!-- <b-card-body>
							<validation-provider
									vid="insurance_plan"
									name="Insurance Plan"
									:rules="{ required: false, max: 50 }"
									v-slot="validationContext"
								>
									<b-form-group label="ICD-10-CM codes" label-for="insurance_plan" label-cols-lg="4">
										<b-form-input
											name="insurance_plan"
											type="text"
											v-model="entity.insurance_plan"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider> -->


						<!-- <validation-provider
									vid="insurance_number"
									name="Insurance Plan ID / Number"
									:rules="{ required: false, max: 50 }"
									v-slot="validationContext"
								>
									<b-form-group
										label="CPT Codes"
										label-for="insurance_number"
										label-cols-lg="4"
									>
										<b-form-input
											name="insurance_number"
											type="text"
											v-model="entity.insurance_number"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider> -->

						<!-- <validation-provider
									vid="insurance_number"
									name="Insurance Plan ID / Number"
									:rules="{ required: false, max: 50 }"
									v-slot="validationContext"
								>
									<b-form-group
										label="ICD-10-PCS codes"
										label-for="insurance_number"
										label-cols-lg="4"
									>
										<b-form-input
											name="insurance_number"
											type="text"
											v-model="entity.insurance_number"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider> -->

						<!-- <validation-provider
									vid="insurance_number"
									name="Insurance Plan ID / Number"
									:rules="{ required: false, max: 50 }"
									v-slot="validationContext"
								>
									<b-form-group
										label="HCPCS codes"
										label-for="insurance_number"
										label-cols-lg="4"
									>
										<b-form-input
											name="insurance_number"
											type="text"
											v-model="entity.insurance_number"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>
							</b-card-body> -->

						<!-- <case-readmissions
								v-if="hasReadmissions"
								v-model="entity.case_readmissions"
								:disabled="saving"
							/>
							<b-card-body v-else>
								<empty-result icon="list"
									>No Codes
									<template #content> Add Billing Codes. </template>
								</empty-result>
							</b-card-body> -->
						<!-- </b-collapse> -->
					</b-card>
				</b-card-body>

				<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button v-if="!hideCancel" block variant="light" @click="cancel" class="btn btn-outline-danger">Cancel</b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4">
							<b-button block variant="light" type="submit" :disabled="saving || loading || !hasPatient" class="btn btn-outline-primary"
								:title="invalid ?  !hasPatient ? 'Patient name is required' :  '' : 'Save'">
								<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
								<span>Save</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
			</b-card>
		</b-form>
	</validation-observer>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { getIsActive } from "@/clients/services/insuranceProviders";
import { formatErrors, getValidationState } from "@/validation";
import { getTodaysDate, getAbsoluteMinimumDate } from "@/shared/helpers/dateHelper";

import CaseReadmissions from "./Readmissions.vue";
import PatientForm from "@/clients/components/Patients/Form.vue";
import PatientSearch from "@/clients/components/Search/Patients.vue";

import InsuranceProviderForm from "@/clients/components/InsuranceProviders/Form.vue";
import DenialReasonSearchMulti from "@/clients/components/Search/DenialReasonsMulti.vue";
import DenialReasonForm from "@/clients/components/DenialReasons/Form.vue";
import ClientEmployeeForm from "@/clients/components/ClientEmployees/Form.vue";
import FacilityForm from "@/clients/components/Facilities/AddForm.vue";
// import AddNPI from "@/clients/views/ClientEmployees/add_npi.vue";
import axios from "axios";
import { debounce } from 'lodash';

export default {
	name: "CaseForm",
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		patientId: {
			type: [Number, String],
			default: null,
		},
		hideCancel: {
			type: Boolean,
			default: false,
		},
		hidePatient: {
			type: Boolean,
			default: false,
		},
		facilityId: {
			type: [Number, String],
			default: null,
		},
		clientEmployeeId: {
			type: [Number, String],
			default: null,
		},
		currentDocument: {
			default: () => {
				return {};
			},
		},
		readmissionLimit: {
			type: Number,
			default: 5,
		},
		currencyMax: {
			type: Number,
			default: 999999999,
		},
		flush: {
			type: Boolean,
			default: false,
		},
		hideEncoreAuditNo: {
			type: Boolean,
			default: false,
		},
		facilityData :{
			default: () => {
				return {
					id:null
				};
			},
		},
	},
	components: {
		CaseReadmissions,
		PatientForm,
		PatientSearch,
		InsuranceProviderForm,
		DenialReasonSearchMulti,
		DenialReasonForm,
		ClientEmployeeForm,
		FacilityForm,
	},
	data() {
		return {
			searchedFacility :false,
			validationProviderRef: null,
			triggereValidation:false,
			mounted:false,
			loading: true,
			saving: false,
			showContent: true,
			currentPatient: {},
			currentInsuranceProvider: {},
			addingPatient: false,
			editingPatient: false,
			addingInsuranceProvider: false,
			addingClientEmployee: false,
			addingFacility: false,
			entity: {
				id: null,
				case_type_id: 2,
				denial_type_id: null,
				client_employee_id: null,
				admit_date: null,
				discharge_date: null,
				insurance_type_id: null,
				insurance_type: null,
				case_readmissions: [],
				facility_id: null,
				facility_name: null,
				visit_number: null,
				mrt_number : null,
				encore_audit_number: null,
				total_claim_amount: null,
				disputed_amount: null,
				reimbursement_amount: null,
				contract_paid_amt_est: null,
				insurance_provider_id: null,
				insurance_plan: null,
				insurance_number: null,
				discipline_id: null, // Unused, join table now
				disciplines: [],
				unable_to_complete: false,
				assigned: null,
				assigned_to: null,
				cptCodes: null,
				icdCodes: null,
				carcs: null,
				rarcs: null,
				planID: null,
				icdCodes10: null,
				has_contract: false,
				showNoContract: true,
				managed_by: null,
				audit_type_id:null,
				insurance_provider_type: null,
				bill_type:null,
				division:null,
			},
			currentDenialReasons: [],
			currentDenialReasons1: [],
			addingDenialReason: false,
			minDate: getAbsoluteMinimumDate(),
			maxDate: getTodaysDate(),
			disciplineIds: [],
			insuranceTypesList: [],
			displayNames: [],
			denialReasons: [],
			selectedDenialReason: null,
            billTypeOptions:[],
			temp_displayName: [],
			facilitySearch: '',
			selectedFacilityId:null,
			term_date: null,
			facilities: [],
			iscontract: null,
			searchResults: [], // Array to hold filtered search results
			selectedResult: null, // Selected result from the dropdown
			insuranceOptions: [],
            // Add more options as needed
			insuranceProviderTypes: [],
			deleteFacilityMode: false,
			today: new Date().toISOString().split('T')[0],
			isEncore:false,
			minDate: null,
			minDischargeDate: null,
			myfacilityId: null,
			mybillTypes: null,
			editfacilityid:null,
			denialData:{},
			showTable:false,
			division:null,
			changedInsuranceProviderUpdateAppealLevel:false,
			rates:{},
			rates2:{},
			initialBillType: null,
			collapseVisible: false,
			yesterday: this.getYesterday(),
            activeProviders: [],
		};
	},
	computed: {
		descriptionFacility() {
			if (this.emptyFacility) {
				return "No facility were found matching your search.";
			} else {
				return "";
			}
		},
		emptyFacility() {
			return this.facilities.length <= 0 && this.searchedFacility == true;
		},
		hasPatient() {
			return this.currentPatient && this.currentPatient.id ? true : false;
		},
		hasClientEmployees() {
			return this.clientEmployees && this.clientEmployees.length > 0;
		},
		canAddReadmission() {
			if (!this.entity.case_readmissions || !this.entity.case_readmissions.length) {
				return true;
			}

			// Limit number of readmissions
			return this.entity.case_readmissions.length < this.readmissionLimit;
		},
		hasReadmissions() {
			return this.entity.case_readmissions && this.entity.case_readmissions.length > 0;
		},
		availableInsuranceTypes() {
			if (this.currentInsuranceProvider) {
				if (
					this.currentInsuranceProvider.insurance_types &&
					this.currentInsuranceProvider.insurance_types.length > 0
				) {
					return this.currentInsuranceProvider.insurance_types;
				}
			}

			return this.insuranceTypes;
		},
		...mapGetters({
			currentUserId: "userId",
			apiToken: "apiToken",
			loadingUsers: "users/loadingActive",
			users: "users/active",
			caseTypes: "caseTypes/all",
			loadingCaseTypes: "caseTypes/loadingAll",
			caseOutcomes: "caseOutcomes/all",
			loadingCaseOutcomes: "caseOutcomes/loadingAll",
			clientEmployees: "clientEmployees/active",
			loadingClientEmployees: "clientEmployees/loadingActive",
			denialTypes: "denialTypes/all",
			loadingDenialTypes: "denialTypes/loadingAll",
			disciplines: "disciplines/all",
			loadingDisciplines: "disciplines/loadingAll",
			insuranceProviders: "insuranceProviders/active",
			loadingInsuranceProviders: "insuranceProviders/loadingActive",
			insuranceTypes: "insuranceTypes/all",
			loadingInsuranceTypes: "insuranceTypes/loadingAll",
			facilities: "facilities/active",
			loadingFacilities: "facilities/loadingActive",
			denialReasonsOptions: "denialReasons/all",
		}),
		filteredInsuranceProviders() {
			// Filter out options with text-field values 'Managed A' and 'Managed B'
			return this.insuranceProviders.filter(provider => provider.name !== 'Managed A' && provider.name !== 'Managed B' && provider.name !== 'Managed Medicaid');
		},
		isManagedByRequired() {
			// Get the selected insurance provider
			const selectedProvider = this.insuranceProviders.find(provider => provider.id === this.entity.insurance_provider_id);

			// Check if the selected provider is 'Managed A' or 'Managed B'
			return selectedProvider && (selectedProvider.name === 'Managed A' || selectedProvider.name === 'Managed B' ||  selectedProvider.name === 'Managed Medicaid');
		},
	},
	mounted() {
		this.fetchActiveProviders();
		this.listDefaultContractPricingSchedules();
		if(this.facilityData.id!= null){
			// this.facilitySearch = this.facilityData.name;
			// this.selectedFacilityId = this.facilityData.id;
			// this.entity.facility_id = this.facilityData.id;
			// this.searchFacilities();
			this.searchResults = [];
			let facilitySearchData = {
				displayName:this.facilityData.display_name,
				id : this.facilityData.id,
				hasContract : this.facilityData.has_contract,
				facilityStatus: this.facilityData.facility_status,
				is_encore: this.facilityData.is_encore,
				bill_type: this.facilityData.bill_type,
				division: this.facilityData.division,
			};
			this.selectFacility(facilitySearchData);
			this.searchResults = [];
		}
		this.fetchFacilityBillType();
		this.additionalDataFetch();
		this.facilityDetails();
		this.fetchDenialReasons();
		this.fetchInsuranceProviderTypes();
		this.fetchContractInsuranceTypes();
		this.fetchAllDenialTypesAndDenialReaons();
		if (this.id) {
			this.refresh();
		} else {
			this.loading = false;
			this.entity.assigned_to = null;

		}

		if (this.facilityId) {
			this.entity.facility_id = this.facilityId;
		}

		if (this.clientEmployeeId) {
			this.entity.client_employee_id = this.clientEmployeeId;
		}

		// Default case type
		if (this.entity.case_type_id === null) {
			if (this.caseTypes && this.caseTypes.length > 0) {
				this.entity.case_type_id = this.caseTypes[0].id;
			}
		}
		this.mounted = true;
		this.triggereValidation = false;
		
	},
	methods: {
	async fetchActiveProviders() {
      try {
		  this.activeProviders = await getIsActive();
      } catch (error) {
        console.error("Error fetching active providers:", error);
      }
    },
		getYesterday() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split('T')[0];  // Format as YYYY-MM-DD
  },
		async listDefaultContractPricingSchedules(){
			try{
				const url = "/client/api/fetchContractPricingDefaultValues";
				const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
				
				if (response.data && Array.isArray(response.data)) {
					response.data.forEach((item) => {
						if (item.id < 7) {
							this.$set(this.rates, item.id-1, item.default_value); // Trigger reactivity
						} else {
							this.$set(this.rates2, item.id - 6, item.default_value); // Trigger reactivity
						}
					});

					
				}
				this.listContractPricingSchedules();
			}
			catch(e){
				
			}
		},
		getValidationState,
		cancel() {
			this.$emit("cancel");
		},
		handleNoResults() {
			this.currentPatient = null; // Clear the current patient when no data is found
		},
		async refresh() {
			if (!this.id) {
				return false;
			}

			try {
				this.loading = true;

				const response = await this.$store.dispatch("cases/get", {
					id: this.id,
				});
				
				this.iscontract = response.facility.has_contract;
				this.editfacilityid = response.facility.id;
			
				this.$set(this, "entity", response);
				const responseSecond = await this.$store.dispatch("cases/get", {
					id: this.id,
				});
				
				this.entity = responseSecond;
				this.$forceUpdate();
				this.currentPatient = response.patient || {};
				// this.entity.insurance_provider_type = responseSecond.insurance_provider_type.id ;
				if (responseSecond && responseSecond.insurance_provider_type) {
					this.entity.insurance_provider_type = responseSecond.insurance_provider_type.id;
				} else {
					this.entity.insurance_provider_type = null;
				}
				this.currentInsuranceProvider = response.insurance_provider || {};

				if (this.entity.denial_reasons) {
					
					this.currentDenialReasons = this.entity.denial_reasons;
				}

				if (response.disputed_amount) {
					this.entity.disputed_amount = parseFloat(response.disputed_amount).toFixed(2);
				}

				if (this.entity.disciplines) {
					this.disciplineIds = this.entity.disciplines.map((item) => item.id);
				}
				// if(response.term_date){
				// 	this.term_date = response.term_date;
				// }
				if(response.insuranceRateType){
					this.entity.insurance_type = response.insuranceRateType;
				}
				if(response.pwrbackDenialReason){
					this.selectedDenialReason = response.pwrbackDenialReason;
				}
				if(response.facility_id){
				
					this.facilitySearch = response.facility.display_name;
					this.term_date = response.term_date;
					this.entity.facility_name = response.facility.facility_status;
					this.entity.has_contract = response.facility.has_contract;
					this.entity.bill_type = response.facility.bill_type;
					this.division=response.division;
				}
				
				this.$emit("loaded", this.entity);
				
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Error getting case details",
				});
			} finally {
				this.loading = false;
				this.initialLoaded = true;
			}
		},
		clearForm() {
			// Clear the form inputs
			this.entity = {};
			// Reset validation state by updating the validationProviderRef
			this.validationProviderRef = null;
			this.$nextTick(() => {
				this.validationProviderRef = {}; // Resetting the reference triggers re-validation
			});
    	},
		async save(e) {
		 // Validation and save logic
		 const confirmMessage = "⚠️ The LOB has been modified, and the changes will be applied to all open cases for this facility. Do you wish to continue and save the changes?";
		if (this.initialBillType!= null) {
			if (!confirm(confirmMessage)) {
				return false;
			}
		}
			// if(this.entity.total_claim_amount == null) {
			// this.collapseVisible = true;
			// }
			let isValid = true;
			let isValidAdmitDate = true;
			let isValidDischargeDate = true;
			//let isValidtotalClaimAmountValidation = true;
			
			this.updateBillType(this.mybillTypes, this.myfacilityId, this.editfacilityid);
			
			
			// Validate 'Total Claim Amount' validation provider
			// if (this.$refs.totalClaimAmountValidationProvider) {
			// 	this.triggereValidation = true;
			// 	if(this.triggereValidation){
			// 		const totalClaimAmountValidationProviderResult = await this.$refs.totalClaimAmountValidationProvider.validate();
			// 		isValidtotalClaimAmountValidation = totalClaimAmountValidationProviderResult.valid && isValidtotalClaimAmountValidation;
			// 	}
            	
				
			// 	console.log('check = ',await this.$refs.admitDateValidationProvider.validate());
			// 	console.log("valid admitdate = ",isValid);
			// } else {
			// 	console.error("Admit date validation provider reference is not defined.");
			// }
			// Validate 'admit_date' validation provider
			if (this.$refs.admitDateValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const admitDateValidationResult = await this.$refs.admitDateValidationProvider.validate();
					isValidAdmitDate = admitDateValidationResult.valid && isValidAdmitDate;
				}
            	
				
				
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}

			// Validate 'discharge_date' validation provider
			if (this.$refs.dischargeDateValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const dischargeDateValidationResult = await this.$refs.dischargeDateValidationProvider.validate();
					isValidDischargeDate = dischargeDateValidationResult.valid && isValidDischargeDate;
				}
				
				
				
			} else {
				console.error("Discharge date validation provider reference is not defined.");
			}
			// Validate 'discharge_date' validation provider
			if (this.$refs.facilityNameValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const facilityNameValidationResult = await this.entity.facility_name !== null;
					if(facilityNameValidationResult==true){
					isValid =true;
				} else {
					
					isValid =false;
				}
				}
				
				
					
			} else {
				console.error("Facility Name validation provider reference is not defined.");
			}
		
			if (isValid && isValidAdmitDate && isValidDischargeDate) {
				try {
					this.saving = true;

					let entity = {
						id: this.id || null,
						case_type_id: this.entity.case_type_id,
						patient_id: this.entity.patient_id,
						facility_id: this.selectedFacilityId > 0?this.selectedFacilityId:this.entity.facility_id,
						denial_type_id: this.entity.denial_type_id,
						case_outcome_id: this.entity.case_outcome_id,
						client_employee_id: this.entity.client_employee_id,

						insurance_provider_id: this.entity.insurance_provider_id,
						insurance_type_id: this.entity.insurance_type_id,
						insurance_plan: this.entity.insurance_plan,
						insurance_number: this.entity.insurance_number,

						total_claim_amount: Number.parseFloat(this.entity.total_claim_amount),
						disputed_amount: Number.parseFloat(this.entity.disputed_amount),
						reimbursement_amount: Number.parseFloat(this.entity.reimbursement_amount),
						visit_number: this.entity.visit_number,

						admit_date: this.entity.admit_date,
						discharge_date: this.entity.discharge_date,

						unable_to_complete: this.entity.unable_to_complete,

						case_readmissions: this.entity.case_readmissions,

						assigned_to: this.entity.assigned_to,

						// cannot use _ids here otherwise the ordering won't be perserved
						denial_reasons: this.currentDenialReasons.map((item) => {
							return { id: item.id };
						}),

						disciplines: {
							_ids: this.disciplineIds,
						},

						//Later Development
						mrt_number: this.entity.mrt_number,
						insurance_provider_type_id: this.entity.insurance_provider_type,
						insuranceRateType: this.entity.insurance_type,
						contract_paid_amt_est: Number.parseFloat(this.entity.contract_paid_amt_est),
						status:this.entity.status
					};

					if (this.currentDocument && this.currentDocument.id) {
						entity.attach_document_id = this.currentDocument.id;
					}
					
					const response = await this.$store.dispatch("cases/save", entity);
					const response11 = await axios.post('/client/contractpricingschedule/edit', {first:this.rates , second:this.rates2 ,id:entity.facility_id,bill_type:this.entity.bill_type});
					
					this.$emit("saved", response);
					this.$emit("update:id", response.id);
					this.$emit("viewCase", response);
				} 
				// catch (e) {
				// 	if (e.response.data.errors) {
				// 		this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
				// 	}

				// 	this.$store.dispatch("apiError", {
				// 		error: e,
				// 		title: "Save Failed",
				// 		message: "Error saving case details. Please check for errors.",
				// 		variant: "warning",
				// 	});
				// } 
				catch (e) {
					if (e.response && e.response.data && e.response.data.errors) {
						this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
					}
					
					this.$store.dispatch("apiError", {
						error: e,
						title: "Save Failed",
						message: "Error saving case details. Please check for errors.",
						variant: "warning",
					});
				}
				finally {
					// this.saving = false;

					// this.$store.dispatch("updateState");

					this.triggereValidation = false;
					this.saving = false;
					// this.$store.dispatch("updateState");
					var data = {
						'case_id':this.id,
						'insurance_provider_id': this.entity.insurance_provider_id,
					};
					if(this.changedInsuranceProviderUpdateAppealLevel){
						const resp = await axios.post('/client/api/updateInsuranceProviderAppealLevelsInAppeal', data);
					}
					this.entity = {};
					this.facilitySearch = "";
					this.term_date=null;
					this.division=null;
					this.clearForm();
				}
			}
			else {
				// Validation failed, do not proceed with saving
				// console.log("Validation failed, cannot save data.");
				// Optionally, you can focus on the first invalid input field
       		}
		},
		// async save(e) {
		// 	 // Validate and save logic
		// 	 let isValid = true;
			
		// 	// Validate 'admit_date' validation provider
		// 	if (this.$refs.admitDateValidationProvider) {
		// 		this.triggereValidation = true;
		// 		if(this.triggereValidation){
		// 			const admitDateValidationResult = await this.$refs.admitDateValidationProvider.validate();
		// 			isValid = admitDateValidationResult.valid && isValid;
		// 		}
            	
				
		// 		console.log('check = ',await this.$refs.admitDateValidationProvider.validate());
		// 		console.log("valid admitdate = ",isValid);
		// 	} else {
		// 		console.error("Admit date validation provider reference is not defined.");
		// 	}

		// 	// Validate 'discharge_date' validation provider
		// 	if (this.$refs.dischargeDateValidationProvider) {
		// 		this.triggereValidation = true;
		// 		if(this.triggereValidation){
		// 			const dischargeDateValidationResult = await this.$refs.dischargeDateValidationProvider.validate();
		// 			isValid = dischargeDateValidationResult.valid && isValid;
		// 		}
				
				
		// 		console.log("valid discharge date = ",isValid);
		// 	} else {
		// 		console.error("Discharge date validation provider reference is not defined.");
		// 	}
		// 	// Validate 'discharge_date' validation provider
		// 	if (this.$refs.facilityNameValidationProvider) {
		// 		this.triggereValidation = true;
		// 		if(this.triggereValidation){
		// 			const facilityNameValidationResult = await this.$refs.facilityNameValidationProvider.validate();
		// 			isValid = facilityNameValidationResult.valid && isValid;
		// 		}
				
				
		// 			console.log("valid facility name = ",isValid);
		// 	} else {
		// 		console.error("Facility Name validation provider reference is not defined.");
		// 	}
		// 	console.log("isValid = ",isValid);
		// 	if (isValid) {
		// 		try {
		// 			this.saving = true;

		// 			let entity = {
		// 				id: this.id || null,
		// 				case_type_id: this.entity.case_type_id,
		// 				patient_id: this.entity.patient_id,
		// 				facility_id: this.selectedFacilityId > 0?this.selectedFacilityId:this.entity.facility_id,
		// 				denial_type_id: this.entity.denial_type_id,
		// 				case_outcome_id: this.entity.case_outcome_id,
		// 				client_employee_id: this.entity.client_employee_id,
		// 				audit_type_id:this.entity.audit_type_id,

		// 				insurance_provider_id: this.entity.insurance_provider_id,
		// 				insurance_type_id: this.entity.insurance_type_id,
		// 				insurance_plan: this.entity.insurance_plan,
		// 				insurance_number: this.entity.insurance_number,

		// 				total_claim_amount: Number.parseFloat(this.entity.total_claim_amount),
		// 				disputed_amount: Number.parseFloat(this.entity.disputed_amount),
		// 				reimbursement_amount: Number.parseFloat(this.entity.reimbursement_amount),
		// 				contract_paid_amt_est: Number.parseFloat(this.entity.contract_paid_amt_est),

		// 				visit_number: this.entity.visit_number,
		// 				mrt_number: this.entity.mrt_number,
		// 				encore_audit_number: this.entity.encore_audit_number,

		// 				admit_date: this.entity.admit_date,
		// 				discharge_date: this.entity.discharge_date,

		// 				unable_to_complete: this.entity.unable_to_complete,

		// 				case_readmissions: this.entity.case_readmissions,

		// 				assigned_to: this.entity.assigned_to,

		// 				// cannot use _ids here otherwise the ordering won't be perserved
		// 				denial_reasons: this.currentDenialReasons.map((item) => {
		// 					return { id: item.id };
		// 				}),

		// 				disciplines: {
		// 					_ids: this.disciplineIds,
		// 				},
		// 				term_date : this.term_date,
		// 				insuranceRateType: this.entity.insurance_type,
		// 				pwrbackDenialReason: this.selectedDenialReason,
		// 				managed_by: this.entity.managed_by,
		// 				insurance_provider_type: this.entity.insurance_provider_type,
		// 			};

		// 			if (this.currentDocument && this.currentDocument.id) {
		// 				entity.attach_document_id = this.currentDocument.id;
		// 			}

		// 			const response = await this.$store.dispatch("cases/save", entity);

		// 			this.$emit("saved", response);
		// 			this.$emit("update:id", response.id);
		// 		} 
		// 		// catch (e) {
		// 		// 	if (e.response.data.errors) {
		// 		// 		this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
		// 		// 	}

		// 		// 	this.$store.dispatch("apiError", {
		// 		// 		error: e,
		// 		// 		title: "Save Failed",
		// 		// 		message: "Error saving case details. Please check for errors.",
		// 		// 		variant: "warning",
		// 		// 	});
		// 		// } 
		// 		catch (e) {
		// 			if (e.response && e.response.data && e.response.data.errors) {
		// 				this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
		// 			}
		// 			console.log("error = ",e);
		// 			this.$store.dispatch("apiError", {
		// 				error: e,
		// 				title: "Save Failed",
		// 				message: "Error saving case details. Please check for errors.",
		// 				variant: "warning",
		// 			});
		// 		}

		// 		finally {
		// 			this.triggereValidation = false;
		// 			this.saving = false;
		// 			this.entity = {};
		// 			this.facilitySearch = "";
		// 			this.term_date=null;
		// 			// this.$store.dispatch("updateState");
		// 			this.clearForm();
		// 		}
		// 	}
		// 	else {
		// 		// Validation failed, do not proceed with saving
		// 		console.log("Validation failed, cannot save data.");
		// 		// Optionally, you can focus on the first invalid input field
//        	}
//		},
		setPatient(patient) {
			this.addingPatient = false;
			this.currentPatient = patient;
		},
		addedNewPatient(patient) {
			this.addingPatient = false;
			this.currentPatient = patient;
		},
		editPatient() {
			this.editingPatient = this.currentPatient.id;
		},
		savedPatient(patient) {
			this.editingPatient = false;
			this.currentPatient = patient;
		},
		update(newValue) {
			this.mybillTypes = newValue;
        
		this.initialBillType = this.mybillTypes;
        },
		async fetchFacilityBillType(){
			try
						{
							const url = "/client/facilitybilltypelist";
								
								const response = await axios.get(url, {
								headers: {
									"Accept": "application/json",
									// You can add other headers here if needed
								},
								});
								
							
							response.data.forEach((item)=>{
								this.billTypeOptions.push(item.bill_type);
							});
							
						}
					catch (error) 
					{
						console.error("Error fetching data:", error.message);
					}
		},
		async getPatient(patientId) {
			try {
				const response = await this.$store.dispatch("patients/get", {
					id: patientId,
				});

				this.currentPatient = response;
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Error getting patient details",
				});
			}
		},
		addReadmission() {
			if (!this.entity.case_readmissions) {
				this.$set(this.entity, "case_readmissions", []);
			}

			this.entity.case_readmissions.push({
				// Defaults
			});
		},
		addedNewInsuranceProvider(insuranceProvider) {
			this.$store.dispatch("insuranceProviders/getAll");
			this.addingInsuranceProvider = false;
			this.currentInsuranceProvider = insuranceProvider;
		},
		async changedInsuranceProvider(id) {
			if (!id || id == null) {
				this.currentInsuranceProvider = {};
				return;
			}

			// @todo Include insurance types to avoid roundtrip to server

			// const match = this.insuranceProviders.find(
			// 	(entity) => entity.id == id
			// );
			// console.log(match);
			// this.currentInsuranceProvider = match;

			const response = await this.$store.dispatch("insuranceProviders/get", {
				id: id,
			});

			this.currentInsuranceProvider = response;
		},
		addedNewDenialReason(denialReason) {
			this.addingDenialReason = false;
			
			this.currentDenialReasons.push(denialReason);
			this.currentDenialReasons1 = [];
		},
		addedClientEmployee(employee) {
			this.addingClientEmployee = false;
			this.$store.dispatch("clientEmployees/getAll");
		},
		addedFacility(facility) {
			this.addingFacility = false;
			this.entity.facility_id = facility.id;
			this.$store.dispatch("facilities/getActive");
		},

		async additionalDataFetch() {
			const url = "/client/insuranceTypesList";

			const response = await axios.get(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
			});
			
			this.insuranceTypesList = response.data;

		},
		// fetch powerbackDenialReasons
		async fetchDenialReasons() {
			try {
				const response = await axios.get('/client/GetdenialReasons');
			
				this.denialReasons.push(response.data);
			} catch (error) {
				console.error('Error fetching denial reasons:', error);
			}
		} ,     
		async fetchInsuranceProviderTypes(){
			try{
				
				const response = await axios.get('/client/GetInsuranceProviderTypes');
				
				this.insuranceProviderTypes.push(response.data);
				
			} catch (error){
				console.error('Error fetching denial reasons:', error);
			}
		} ,
		async fetchContractInsuranceTypes(){
			try {
				
				const response = await axios.get('/client/contractinsurancelist');
			
				this.insuranceOptions = response.data.map(item => {
					return { text: item.insurance_type, value: item.id };
				});
			} catch (error) {
				console.error('Error fetching denial reasons:', error);
			}
		},
		async facilityDetails(){
			if(this.facilitySearch.length >=2){
				
				const response = await axios.get('/client/searchFacility',{
				params: {
					search: this.facilitySearch,
				},
				});
				
				this.facilities = response.data; // save all facilities for later use
				let temp_facilities = response.data;
				
				this.searchedFacility=true;
				if(response.data.length==0){
					
				}
				// Check if this.facilities is defined and is an array
				// Use the map method to directly extract display_name values
				// this.displayNames = this.facilities
				// 	.map((facility) => facility.display_name)
				// 	.filter((displayName) => displayName !== null && displayName !== undefined);


				this.displayNames = this.facilities.map((facility) => ({ id: facility.id, displayName: facility.display_name, facilityStatus: facility.facility_status, hasContract: facility.has_contract , is_encore:facility.is_encore , is_duplicate:facility.is_duplicate ,has_contract:facility.has_contract, bill_type:facility.bill_type,division:facility.division}))


					const searchQuery = this.facilitySearch.toLowerCase();
						const startsWithSearch = this.displayNames.filter(item => {
							const name = (item && item.displayName) || ''; // Ensure a valid string
							return name.toLowerCase().startsWith(searchQuery);
						});

						const containsSearch = this.displayNames.filter(item => {
							const name = (item && item.displayName) || ''; // Ensure a valid string
							return name.toLowerCase().includes(searchQuery) && !name.toLowerCase().startsWith(searchQuery);
						});
						
						this.searchResults = startsWithSearch.concat(containsSearch);


				// this.temp_displayName.push(this.facilities.map((facility) => facility.display_name));
			
				// console.log('temp_displayNames', JSON.stringify(this.temp_displayName));
			}
			if(this.facilityData.id != null){
				this.searchResults = [];
			}
		},

		logSelectedFacilityDetails(item) {
			
			const selectedDisplayName = item.displayName;
			const selectedFacility = this.facilities.find(
				(facility) => facility.display_name === selectedDisplayName
			);

			if (selectedFacility) {
			
				const fetchFacilityContractData = async () => {
				try {
					// const url = "/client/findFacilityContract/";
					const url = `/client/findFacilityContract/${selectedFacility.id}`;

					const response1 = await axios.get(url, {
						headers: {
							"Accept": "application/json",
							// You can add other headers here if needed
						},
					});
					// TODO: CHECK IF THERE IS ANY FACILITY CONTRACT FOUND
					
					if(response1.data !== null){
						// if there is any, set term date value
						if(response1.data.term_date && response1.data.term_date !== undefined && response1.data.term_date != null){
							this.term_date = response1.data.term_date; 
						}else{
							this.term_date = 'Unknown'
						}
					}else{
						this.term_date = 'Unknown'
					}
					
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			};

			// Call the async function
			fetchFacilityContractData();
			}
		},
		async searchFacilities() {
				if (this.facilitySearch.length < 2) {
					this.term_date = null;
					this.entity.facility_name = null;
					this.entity.bill_type = null;
					this.entity.has_contract = false;
					this.entity.isEncore = false;
					this.entity.has_contract = false;
					this.division = null;
				}
				if (this.facilitySearch.length >= 2) {
					await this.facilityDetails();

					const searchQuery = this.facilitySearch.toLowerCase();
					const startsWithSearch = this.displayNames.filter(item => {
						const name = (item && item.displayName) || ''; // Ensure a valid string
						return name.toLowerCase().startsWith(searchQuery);
					});

					const containsSearch = this.displayNames.filter(item => {
						const name = (item && item.displayName) || ''; // Ensure a valid string
						return name.toLowerCase().includes(searchQuery) && !name.toLowerCase().startsWith(searchQuery);
					});

					this.searchResults = startsWithSearch.concat(containsSearch);
				}

			},

		selectFacility(item) {
			// Handle the selected facility, if needed
			
			this.facilitySearch = item.displayName;
			this.selectedFacilityId = item.id;
			this.myfacilityId=item.id;
		
			this.entity.facility_name  = item.facilityStatus;
			this.entity.has_contract = item.hasContract;
			this.entity.showNoContract = item.hasContract;
			this.iscontract = item.hasContract;
			this.isEncore = item.is_encore;
			this.entity.bill_type = item.bill_type;
			this.mybillTypes=item.bill_type;
		
			this.logSelectedFacilityDetails(item);
			this.searchResults = [];
			this.isbilltype = true;
			this.division=item.division;
		},

		toggleDeleteMode() {
			this.deleteFacilityMode = !this.deleteFacilityMode;
		},
		cancelFacilityDeleteMode(){
			this.currentDenialReasons.forEach((item) => (item.checked = false));
			this.deleteFacilityMode = false;
		},
		removeSelectedItems() {
			this.currentDenialReasons = this.currentDenialReasons.filter((item) => !item.checked);
			this.deleteFacilityMode = false; // Turn off delete mode after removing items
		},
		toggleContent() {
     		 this.showContent = !this.showContent;
      	 },
		
     updateDischargeMinDate() {
      if (this.entity.admit_date) {
        this.minDischargeDate = this.entity.admit_date;
		// this.entity.discharge_date = null;
      } else {
        this.minDischargeDate = null; 
      }
      this.validateDates();
		},
	
		updateBillType() {
    let id;

    // Check for facility ID
    if (this.myfacilityId) {
        id = this.myfacilityId;
    } else if (this.editfacilityid) {
        id = this.editfacilityid;
    } else {
        console.error('No facility ID provided.');
        return; // Exit if no ID is available
    }

			
    // Make API request
    axios.post('/client/editBillTypes', {
        facility_id: id,
        bill_type: this.mybillTypes
    })
    .then(response => {
       
        if (response.data.status === 'success') {
          
            // Optionally, update the UI to reflect the change
        } else {
          
        }
    })
    .catch(error => {
        console.error('There was an error with the request!', error);
        const errorMessage = error.response ? error.response.data.message : 'An error occurred while updating the bill type. Please try again later.';
       
    });
},


    validateDates() {
      if (this.entity.admit_date && this.entity.discharge_date) {
        const admitDate = new Date(this.entity.admit_date);
        const dischargeDate = new Date(this.entity.discharge_date);
       

        // if (dischargeDate < admitDate) {
        //   this.$refs.dischargeDateValidationProvider.applyResult({
        //     errors: ['End DOS must be the same as or after Begin DOS'],
        //   });
        // } else {
        //   this.$refs.dischargeDateValidationProvider.applyResult({
        //     errors: [],
        //   });
        // }
		if (this.$refs.dischargeDateValidationProvider) {
				if (dischargeDate < admitDate) {
					this.$refs.dischargeDateValidationProvider.applyResult({
						errors: ['End DOS must be the same as or after Begin DOS'],
					});
				} else {
					this.$refs.dischargeDateValidationProvider.applyResult({
						errors: [],
					});
				}
			} else {
				
			}
    	
      }
    },
	async fetchAllDenialTypesAndDenialReaons(){
		const resp = await axios.post('/client/api/getAllDenialTypeAndDenialReasonForAppealForCase', {
					'case_id':this.id
			});
		this.denialData = resp.data;
		
		if(this.denialData.length > 0){
			this.showTable = true;
		}
		else{
			this.showTable = false;
		}
	},
	},
	created() {
		// Create a debounced version of the facilityDetails method
		this.debouncedSearch = debounce(async () => {
		this.loading = true;
		await this.facilityDetails();
		this.loading = false;
		}, 300);

		// Attach the debouncedSearch to an instance property
		// this.debouncedSearch = debouncedSearch;
	},
	watch: {
		patientId: {
			immediate: true,
			handler(val) {
				if (val !== null) {
					this.entity.patient_id = val;
					this.getPatient(val);
				}
			},
		},
		'entity.admit_date': function() {
		this.updateDischargeMinDate();
		},
		'entity.discharge_date': function() {
		this.validateDates();
		},
		currentPatient(newVal) {
			if (newVal && newVal.id) {
				this.entity.patient_id = newVal.id;
			}
		},
		currentInsuranceProvider(newVal) {
			if (newVal && newVal.id) {
				//this.$set(this.entity, 'insurance_provider_id', newVal.id);
				this.entity.insurance_provider_id = newVal.id;
			}

			if (newVal && newVal.default_insurance_type_id) {
				if (!this.entity.insurance_type_id || this.entity.insurance_type_id == null) {
					this.entity.insurance_type_id = newVal.default_insurance_type_id;
				}
			}
		},
		// 'entity.insurance_provider_id': function(newValue, oldValue) {
		// 	this.entity.insurance_provider_type = null;
		// 	this.entity.insurance_type = null;
		// 	this.entity.managed_by = null;
		// 	this.entity.audit_type_id=null;
		// },
		'entity.insurance_provider_id': function(newValue, oldValue) {
			if (this.mounted) {
				this.entity.insurance_provider_type = null;
				this.entity.insurance_type = null;
				this.entity.managed_by = null;
				this.entity.insurance_type_id=null;
				this.changedInsuranceProviderUpdateAppealLevel = true;
			}
		},
		'entity.bill_type': function(newBillType) {
			this.mybillTypes = newBillType;
		}
    }
};
</script>
<style scoped>
.custom-dropdown-option {
	border: 1px solid #ccc;
	border-radius: 4px;
	padding: 10px;
	margin-bottom: 10px;
	background-color: #fff;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.custom-rounded-border {
	border: 1px solid #007bff;
	/* Set your desired border color and thickness */
	border-radius: 5px;
	/* Set your desired border radius */
}

.custom-dropdown-option {
	position: absolute;
	top: 100%;
	/* Position the dropdown below the input */
	left: 0;
	width: 100%;
	/* Make the dropdown full-width */
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	overflow: hidden;
	/* Hide overflow content */
	z-index: 1000;
}

.custom-option-col {
	margin-left: 10px;
	cursor: pointer;
	transition: background-color 0.3s, color 0.3s;
}

.custom-option-col:hover {
	background-color: #f5f5f5;
	color: #9bb8d7;
}

.option-content {
	margin-top: 2px;
	margin-bottom: 2px;
}

.selected-item {
  border: 1px solid #ccc;
  padding: 8px;
  margin: 8px 0;
  width:100%;
}
.border_bottom {
  /* padding: 10px; */
  border-bottom: 1px solid #ddd;
  transition: border-color 0.3s;
  margin-top:5px;
}
.multiselect__tags-wrap {
    display: none !important;
}
.multiselect__tags-wrap .multiselect__tag {
  display: none !important;
}
</style>